import React from "react";
import SocialIcons from "../../components/SocialIcons";

export const PageNotFound = () => {
    return (
        <>
        <h1>Page Not Found!</h1>
        <p>Why not try another page or reach out to us</p>
        <SocialIcons />
        </>
    );
};